import defaultThumbnail from '../../assets/default-project-thumbnail.webp'
import missionProjects from '../../missions'
import { Mission, SiteType } from '../../openapi'
import { toSiteAliasSlug } from '../preview/previewDisplayMode'

const resolveBundledMission = (mission: Mission, siteName: string) => {
  const bundledMissions = missionProjects[siteName]
  if (!bundledMissions) {
    return undefined
  }
  return (
    bundledMissions[`${mission.slug}_${mission.num}`] ??
    bundledMissions[`${toSiteAliasSlug(mission.slug, siteName)}_${mission.num}`]
  )
}

/**
 * マイプロジェクト一覧カードのサムネイル URL を決める。優先順は
 * DB 管理のサムネイル（mission.thum）→ アプリ同梱のミッション別サムネイル
 * （missionProjects の thumbnail）→ 共通デフォルト。コピーしたプロジェクトは
 * 従来どおり常にデフォルトを使う。
 *
 * 同梱サムネイルはミッション自身の siteName のキー空間で解決する
 * （getAllMissions は相互リミックスのため両サイトのミッションを返す）。
 * siteName 未設定時のみ閲覧中サイト（userSiteName）で引く。キーは
 * まず素の slug で引き、見つからなければサイトごとの別名 slug で再試行する。
 */
export const getProjectThumbnail = (
  isCopy: boolean | undefined,
  mission: Mission | undefined,
  userSiteName: SiteType | undefined,
): string => {
  if (isCopy) {
    return defaultThumbnail
  }
  if (mission?.thum) {
    return mission.thum
  }
  const siteName = mission?.siteName ?? userSiteName
  const bundledThumbnail =
    mission && siteName ?
      resolveBundledMission(mission, siteName)?.thumbnail
    : undefined
  if (bundledThumbnail) {
    return bundledThumbnail
  }
  return defaultThumbnail
}
